<template>

    <div class="layout__padding-clear layout__width-100">

        <div class="layout__position__relative">
            <div class="layout__padding-clear">
                <div class="text__align-center text__colour-teal layout__padding__top-40px"><h2>About Ravensworth</h2></div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-70 text__align-center layout__padding-40px-0">
            <div class="text__size-30 text__colour-teal layout__padding-40px-0">The UK’s number one for property print</div>

            <p class="layout__padding-clear layout__width-80 text__line-height-15">Ravensworth has been the trusted
                print and marketing provider to the property industry since 1973. We
                pride ourselves on our great people – the kind who’ll go out of their way to provide extraordinary
                customer service to you, our clients. We work with a mix of independent estate agents, multi-branch
                clients and large corporate accounts alongside many property professionals, which makes us the largest
                provider of creative marketing and on-demand print in the industry.</p>

            <div class="layout__padding-40px-0">
                <div class="layout__padding-clear">
                    <video class="layout__width-80" controls autoplay>
                        <source src="https://rpsassets.blob.core.windows.net/rpsimages/Ravensworth-Nock-Deighton-Testimonial.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>

        <div class="colour__background-light-grey layout__overflow-hidden layout__padding-20-0 text__line-height-15">
            <div class="layout__padding-clear layout__width-70 text__align-center">
                <div class="component__columns-4">
                    <div class="text__size-30 text__colour-teal layout__padding-20-0 text__style-bold-900">45</div>
                    <h4>Years in the industry</h4>
                </div>

                <div class="component__columns-4">
                    <div class="text__size-30 text__colour-teal layout__padding-20-0 text__style-bold-900">4,500</div>
                    <h4>Property clients</h4>
                </div>

                <div class="component__columns-4">
                    <div class="text__size-30 text__colour-teal layout__padding-20-0 text__style-bold-900">180</div>
                    <h4>Weekly design jobs</h4>
                </div>

                <div class="component__columns-4">
                    <div class="text__size-30 text__colour-teal layout__padding-20-0 text__style-bold-900">1,100</div>
                    <h4>Daily print jobs</h4>
                </div>
            </div>
        </div>

        <div class="layout__overflow-hidden colour__background-teal layout__padding-40px-0 text__colour-white text__line-height-15">
            <div class="layout__padding-clear layout__width-70 text__align-center">

                <div class="component__columns-2">
                    <h3>What we do</h3>

                    <p class="text__colour-white layout__padding-20-0">We offer you a complete range of products and
                        services for your property business, backed up by a strong support team and technical
                        expertise.</p>
                    <p class="text__colour-white">Whether you’re looking for hassle free word templates, a simple
                        web-to-print platform, a new look for your brand or state of the art CGI, we’ve got the
                        experience and the people to help.</p>
                </div>

                <div class="component__columns-2">
                    <h3>How we support</h3>

                    <p class="text__colour-white layout__padding-20-0">Our team make sure you get the best service for
                        your business needs.</p>
                    <p class="text__colour-white">If you’ve got a query or need a quote, our dedicated customer services
                        team are happy to help. If you’re looking for something a bit more in-depth, our technical
                        specialists can explain our technology, print options, paper weights and how to get the most out
                        of your next campaign.</p>
                    <p class="text__colour-white layout__padding-20-0">If you’re just in need of some inspiration, hop
                        on a call with one of our designers – we’re full of ideas!</p>
                </div>
            </div>
        </div>

        <div class="layout__overflow-hidden text__line-height-15 layout__width-70 layout__padding-clear">
            <div class="text__size-36 text__colour-teal layout__width-100 text__align-center text__style-bold-900 text__line-height-2 layout__padding__top-20px">
                What our customers say
            </div>

            <div class="layout__padding-clear layout__width-100 text__align-center">
                <carousel :per-page="1" :autoplayTimeout="5000" :autoplay="true" :paginationSize="20" paginationActiveColor="#00859c" :loop="true" :speed="1500">
                        <slide class="layout__padding-clear layout__height-300px" v-for="(test) in testimonials">
                            <img class="layout__padding-clear layout__width-150px" v-bind:src=test.logo>
                            <div class="layout__padding-clear layout__width-80">
                                <p class="layout__padding-20px text__size-18 text__line-height-30px">{{test.message}}</p>
                                <p class="text__size-16">{{test.company}}</p>
                            </div>
                        </slide>
                </carousel>
            </div>
        </div>
    </div>

</template>

<script>
    import Router from '../router';
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: "about",
        mixins: [],
        components: {
            Carousel,
            Slide
        },
        mounted() {
        },
        data() {
            return {
                url: 'images/ravensworth/agentsLogos/connells.png',
                callbackRequest: {
                    name: '',
                    company: '',
                    postcode: '',
                    emailAddress: '',
                    phoneNumber: '',
                    interested: '',
                    message: ''
                },
                testimonials: [
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/js.png',
                        message: '“Proactive, creative, great problem solving attitude… Ravensworth shares Jackson-Stops\' insistence for the highest possible standards."',
                        company: 'Nick Ferrier - Jackson-Stops'
                    },
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/connells.png',
                        message: '"Ravensworth produce high quality CGI every time and pay great attention to the features that turn a house into a home. They\'re an invaluable marketing partner that add real value."',
                        company: 'Paul Matthews - Connells'
                    },
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/realEstates.png',
                        message: '"Ravensworth\'s Marketing Toolkit helps us cut down on time and money without comprimising on quality and we can deliver fast, effecting marketing campaigns."',
                        company: 'Peter Clifford - Reel Estates'
                    },
                    {
                        logo: 'https://rpsassets.blob.core.windows.net/rpsimages/images/testimonials/holroyds.png',
                        message: '“Ravensworth share our vision and passion for the industry. They’ve helped us create the perfect marketing plan to stand out from the crowd. Their quality and attention to detail impress on a daily basis.”',
                        company: 'Chris Holroyd - Holroyds Estate Agents'
                    }

                ],
                topics: [{
                    label: 'Products',
                    options: [{
                        value: 'Print',
                        label: 'Print'
                    },
                        {
                            value: 'Digital',
                            label: 'Digital'
                        },
                        {
                            value: 'Template Collections',
                            label: 'Template Collections'
                        },
                        {
                            value: 'Packages',
                            label: 'Packages'
                        }
                    ]
                }, {
                    label: 'Services',
                    options: [{
                        value: 'Design Studio',
                        label: 'Design Studio'
                    }, {
                        value: 'Land & New Homes',
                        label: 'Land & New Homes'
                    }, {
                        value: 'Marketing Toolkit',
                        label: 'Marketing Toolkit'
                    }, {
                        value: 'Photofixr',
                        label: 'Photofixr'
                    }]
                }],
                rules: {
                    name: [{
                        required: true, message: 'Name required', trigger: 'blur'
                    }],
                    company: [{
                        required: true, message: 'Company required', trigger: 'blur'
                    }],
                    postcode: [{
                        required: true, message: 'Postcode required', trigger: 'blur'
                    }],
                    emailAddress: [{
                        required: true, message: 'Email Address required', trigger: 'blur'
                    }],
                    phoneNumber: [{
                        required: true, message: 'Phone Number required', trigger: 'blur'
                    }],
                    message: [{
                        required: true, message: 'Message required', trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            sendEmail(callbackRequest) {
                this.$refs[callbackRequest].validate((valid) => {
                    if (valid) {

                    } else {
                        return false;
                    }
                })
            }
        }
    };
</script>